import {register} from '../vendor/theme-scripts/theme-sections';
import popupVideoSection from '../features/popup-video';
import galleryZoomSection from '../features/gallery-zoom';
import {customScrollbar} from '../features/custom-scrollbar';

register('gallery', [galleryZoomSection, popupVideoSection, customScrollbar]);
